<template>
  <div>
    <base-header type="gradient-success" class="pb-6">
    </base-header>
    <div class="container">
      <div class="row mt-3 ">

        <div class="col-6">
          <label>Seleccione el rango de fechas de las ordenes a auditar</label>
          <base-input addon-left-icon="ni ni-calendar-grid-58">
            <flat-picker slot-scope="{focus, blur}"
                         @on-open="focus"
                         @on-close="blur"
                         :config="config"
                         class="form-control datepicker"
                         v-model="date">
            </flat-picker>
          </base-input>

        </div>
        <div class="col-6">
          <base-button class="mt-4" @click="search" id="search">Buscar</base-button>
        </div>
        <div class="col-12 d-flex justify-content-center">
          <vue-excel-xlsx
              v-if="orders.length > 0"
              style="cursor: pointer;border-radius: 7px;"
              class="btn-default col-6"
              :data="downloads"
              :columns="columns"
              :filename="'Auditoria de ordenes '+ date"
              :sheetname="'audioria'"
          >
            <span><i class="fa fa-file-excel-o"></i> Descargar Auditoria</span>
          </vue-excel-xlsx>
        </div>
      </div>

      <div v-if="orders.length > 0" class="mt-3">
        <div class="col-12 " v-for="(item,index) in orders" v-bind:key="item.id_order">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle="'accordion-productdetails'+index" variant="primary">Orden
                <strong>{{ item.id_order }}</strong> - Auditada en un
                {{ item.audit_percentage.audit_percentage.toFixed(2) }} %
              </b-button>
            </b-card-header>

            <b-collapse
                :id="'accordion-productdetails'+index"
                :accordion="'productdetails-accordion'+index"
            >

              <div class="container-fluid">
                <div class="row">
                  <div>
                    <span>{{ timeorder(item.auditory) }}</span>
                    <div v-for="(i,index) in item.auditory" :key="index">
                      <strong>{{ i.User.name + ' ' + i.User.last_name }}</strong> <br>
                      <span><strong>Acción: </strong>{{ i.made }}</span> <br>
                      <span><strong>Fecha: </strong> {{ formatedate(i.date) + formatehora(i.date) }}</span> <br>
                      <span><strong>Descripción: </strong> {{ i.description }}</span> <br>
                      <span><strong>Detalle: </strong> {{ i.details }}</span>
                    </div>
                  </div>


                </div>
              </div>
            </b-collapse>
          </b-card>


        </div>
      </div>

      <div v-if="noresult">
        <span>No se encontraron resultados</span>
      </div>
      <div class="content-loading" id="content-loading">
        <div class="img-loading"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {order_service} from "@/services/order/OrderService";
import {bus} from '@/components/Order/bus-order'
import _ from "lodash";

export default {
  name: "Auditoria.vue",
  data() {
    return {
      orders: [],
      downloads: [],
      noresult: false,
      date: '',
      config: {
        mode: "range",
        enableTime: true,
        dateFormat: "Y-m-d H:i:ss",
        allowInput: true,
        locale: {
          firstDayOfWeek: 1,
          weekdays: {
            shorthand: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
            longhand: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
          },
          months: {
            shorthand: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Оct', 'Nov', 'Dic'],
            longhand: ['Enero', 'Febreo', 'Мarzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          },
        },

      },
      columns: [
        {label: "Orden", field: "id_order"},
        {label: "Fecha", field: "date"},
        {label: "Nombre", field: "User.name"},
        {label: "Apellido", field: "User.last_name"},
        {label: "Hizo", field: "made"},
        {label: "Descripcion", field: "description"},
        {label: "Detalles", field: "details"},
        {label: "%Porcentaje Auditoria", field: "audit_percentage"}

      ]
    }
  },
  methods: {
    timeorder(datos) {
      datos = _.orderBy(datos, ['date'], ['asc']);
      const fechas = datos.map((dato) => dato.date);
      const primeraFecha = new Date(fechas[0]); // primera fecha del array
      const ultimaFecha = new Date(fechas[fechas.length - 1]); // última fecha del array
      const milisegundos = ultimaFecha - primeraFecha; // milisegundos transcurridos entre la primera y última fecha
      const segundos = Math.floor(milisegundos / 1000);
      const minutos = Math.floor(segundos / 60);
      const horas = Math.floor(minutos / 60);
      const dias = Math.floor(horas / 24);
      const tiempo = {
        days: dias,
        hours: horas % 24,
        minutes: minutos % 60,
        seconds: segundos % 60
      }
      return `Ha transcurrido un total de ${tiempo.days} días, ${tiempo.hours} horas, ${tiempo.minutes} minutos y ${tiempo.seconds} segundos en tiempo de procesamiento de la orden.`


    },
    search() {
      this.orders = []
      document.getElementById("content-loading").classList.add("active");
      this.date = this.date.split(" to ")
      const data = {
        "from": this.date[0],
        "to": this.date[1]
      }
      order_service.GetAuditOrders(data)

    },
    formatedate(value) {
      var date = new Date(value);
      return date.toISOString().slice(0, 10);
    },
    formatehora(fecha) {
      var fechas = new Date(fecha)
      return fechas.toLocaleTimeString()
    }


  },
  created() {
    bus.$on('GetAuditOrders', (response) => {
      console.log(response)
      document.getElementById("content-loading").classList.add("inactive");
      if (response.length === 0) {
        this.noresult = true
        this.orders = []
      } else {
        this.downloads = response
        this.noresult = false
        response = _.forEach(response, function (item) {
          if (item.details != '') {
            let details = JSON.parse(item.details);
            let us = '';
            let products = '';
            if (details.length > 0) {
              if (details[0].usersAssing !== []) {
                for (const u in details[0].assigneduser) {
                  us += details[0].assigneduser[u].name + ' ' + details[0].assigneduser[u].last_name + ', '
                }
              }
              if (details[0].products !== []) {
                for (const u in details[0].products) {
                  let cantidad = ''
                  let count = 0
                  if (typeof details[0].products[u].quantity !== "undefined") {
                    cantidad = ', Cantidad pedida: ' + details[0].products[u].quantity + ' '
                    count += 1
                  }
                  let cantidadcheck = ''
                  if (typeof details[0].products[u].quantityCheck !== "undefined") {
                    cantidadcheck = ', Cantidad Enviada: ' + details[0].products[u].quantityCheck + ' '
                    count += 1
                  }
                  let precio = ''
                  if (typeof details[0].products[u].price !== "undefined") {
                    precio = ', Precio: ' + details[0].products[u].price + ' '
                    count += 1
                  }
                  let unidad = ''
                  if (typeof details[0].products[u].unit !== "undefined") {
                    unidad = ', Unidad: ' + details[0].products[u].unit + ', '
                    count += 1
                  }
                  let product = ''
                  if (count > 0) {
                    product = 'Producto: ' + details[0].products[u].name
                  }
                  products += product + cantidad + cantidadcheck + precio + unidad
                }
              }
              if (us != '') {
                us = 'Usuarios Agregados: ' + us
              }
              if (products != '') {
                products = 'Productos modificados: ' + products
              }
              item.details = us + " " + products
            }
          }
          if (item.orderproduct != '') {
            let products = JSON.parse(item.orderproduct)
            products = _.map(products.body.hits.hits, "_source")
            if (products.length > 0) {
              let itemsAudited = 0
              let items = products.length
              _.each(products, (o) => {
                if (o.audit) {
                  itemsAudited += 1
                }
              })
              item.audit_percentage = (itemsAudited * 100) / items
            } else {
              item.audit_percentage = 0
            }
          }
        })
        this.orders = _.chain(response).groupBy("id_order").map(function (v, i) {
          return {
            id_order: i,
            auditory: _.map(v),
            audit_percentage: _.maxBy(v, 'date')
          }
        }).value();

        //console.log(this.orders)
      }


    })
  }
}
</script>

<style scoped>
.content-loading {
  position: relative;
}
</style>

